import React from 'react';
import './styles/index.css';
import 'react-phone-number-input/style.css';
import AppRouter from './routes';
import { AuthProvider } from './context/AuthContext';
import { PublicProvider } from './context/PublicContext';
import "animate.css";

const App: React.FC = () => {
  return (
    <AuthProvider>
      <PublicProvider>
        <AppRouter />
      </PublicProvider>
    </AuthProvider>
  );
};

export default App;